import React, {useContext} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import {blue} from "@material-ui/core/colors";
import {StoreContext} from "../../store/context";
import Button from "@material-ui/core/Button";
import {useViewport} from "../viewport";

const useStyles = makeStyles({
    root: {
        width: '100%',
    },
    container: {
        maxHeight: 440,
    },
});

export default function StickyHeadTable(props) {
    const classes = useStyles();
    const { state, actions } = useContext(StoreContext);
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(100);

    const { width } = useViewport();
    const widthRatio = width< 1000 ? 0.6 : 1;
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    return (
        <Paper className={classes.root}>
            <TableContainer className={classes.container}>
                <Table stickyHeader aria-label="sticky table">
                    <TableHead >
                        <TableRow>
                            {props.columns.map((column) => (
                                <TableCell
                                    key={column.id}
                                    align={column.align}
                                    style={{ minWidth: column.minWidth * widthRatio, background: "#3f51b5", color: "white" }}
                                >
                                    {column.label}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {props.rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                            return (
                                <TableRow hover role="checkbox" tabIndex={-1} key={row.uuid}>
                                    {props.columns.map((column) => {
                                        let value = row[column.id];
                                        let disable = false;
                                        if (column.id === "action"){
                                            // if (row["paymentStatus"] === "PAID"){
                                            //     disable = true
                                            // }
                                            return(
                                                <TableCell key={column.id} align={column.align}>
                                                    <Button variant="contained" color="secondary"
                                                            onClick={() => {props.buttonAction(row.uuid == null? row.id : row.uuid)}}
                                                            disabled={disable}>
                                                        {props.buttonContent}
                                                    </Button>
                                                </TableCell>
                                            )
                                        }
                                        if (column.id === "totalOwedFee"){
                                            const fee = row["totalTuitionFee"] ? row["totalTuitionFee"] : row["totalMiscFee"]
                                            if (row["paymentStatus"] === "PAID"){
                                                value = row["totalOwedFee"];
                                            } else if (fee) {
                                                value = row["totalOwedFee"] === 0 ? fee : row["totalOwedFee"];
                                            } else {
                                                value = row["totalOwedFee"];
                                            }
                                        }

                                        return (
                                            <TableCell key={column.id} align={column.align}>
                                                {column.format ? column.format(value) : value}
                                            </TableCell>
                                        );
                                    })}
                                </TableRow>
                            );
                        })}

                        {props.totalAmount && <TableRow>
                            <TableCell/>
                            <TableCell/>
                            <TableCell/>
                            <TableCell/>
                            <TableCell align="right">Total(RM)</TableCell>
                            <TableCell align="right">{props.totalAmount}</TableCell>
                        </TableRow>}
                    </TableBody>
                </Table>
            </TableContainer>
            <TablePagination
                rowsPerPageOptions={[10, 25, 100]}
                component="div"
                count={props.rows.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
            />
        </Paper>
    );
}
